import type { MeterBarChartLegendProps } from '../../shared/types/meter-bar-legend.js';

export const Legend = (_props: MeterBarChartLegendProps) => null;

Legend['displayName'] = 'MeterBarChart.Legend';
